export default {
	bind (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// Verifica que el clic no fue dentro del elemento
			if (!(el === event.target || el.contains(event.target))) {
				// Llama el método que pasaste en la directiva
				binding.value(event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	unbind (el) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	}
};